import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";



import { AuthProvider, useAuth } from "./contexts/AuthContext";
import UnregisteredView from "./components/UnregisteredView";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const { isUnregisteredError, loading } = useAuth();



  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  if (isUnregisteredError) {
    return <UnregisteredView />;
  }

  return <AppRoutes />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
